import { performRequest } from "../performRequest"



export const getWeather = (params) => {
    return performRequest("get", "/api/ess/dashboard/weather/",params)
}

export const getBirthday = (id, params) => {
    return performRequest("get", `api/ess/dashboard/birthday/`,params)
}


export const getAnniversary = (id, params) => { 
    return performRequest("get", `api/ess/dashboard/job-anniversary/`,params)
}
export const getNewJoiners = (id, params) => {
    return performRequest("get", `api/ess/dashboard/new-joiners/`,params)
}

export const getTerminated = (id, params) => {
    return performRequest("get", `api/ess/dashboard/employee-resigned/`,params)
}

export const getPublicHoliday = (id, params) => {
    return performRequest("get", `api/ess/dashboard/public-holiday/`,params)
}

export const getEmployeeStatus = (id, params) => {
    return performRequest("get", `api/ess/dashboard/public-holiday/`,params)
}
export const getEmployeeHeadCount = (id, params) => {
    return performRequest("get", `api/ess/dashboard/employee-head-count/`,params)
}

export const getEmployeeLeaveStatus = ( params) => {
    return performRequest("get", `api/ess/dashboard/leave-stats/`,params)
}

// Employee Stats
export const getEmployeeStatstics = (params) => {
    return performRequest("get", `api/ess/dashboard/employee-stats/`,params)
}

// Employee Nationality Mix
export const getEmployeeNationalityMix = (params) => {
    return performRequest("get", `api/ess/dashboard/employee-nationality-stats/`,params)
}

// Employee Department Mix
export const documentExpiry = (params) => {
    return performRequest("get", `api/ess/dashboard/document-expiry/`,params)
}

// Announcement List
export const getAnnouncementList = (params) => {
    return performRequest("get", `api/ess/announcement-list/`, params)
}


